import axios from 'axios';
import config from 'config/Config'

const API = axios.create({
    baseURL: config.API_URL
});

export default API;